module.exports = __webpack_public_path__ + "img/fullscreen-close.c141c957.svg";